module.exports = __webpack_public_path__ + "img/aio_cover_sol.ceec2608.png";